import {CHECKOUT_PROMO_KEY, GUEST_CART_KEY, TOKEN_KEY} from './session';

async function currentScope() {
    const token = localStorage.getItem(TOKEN_KEY);
    const cart = localStorage.getItem(GUEST_CART_KEY);
    if (!token || !cart || !window.crypto?.subtle) return null;
    const isCurrent = () => token === localStorage.getItem(TOKEN_KEY) && cart === localStorage.getItem(GUEST_CART_KEY);
    const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
    if (!isCurrent()) return null;
    const owner = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
    return {owner, cart, isCurrent};
}

export function clearCheckoutPromo() {
    try { localStorage.removeItem(CHECKOUT_PROMO_KEY); } catch { /* Storage may be unavailable. */ }
}

export async function saveCheckoutPromo(code, isCurrent = () => true) {
    try {
        const scope = await currentScope();
        if (!scope || !scope.isCurrent() || !isCurrent() || typeof code !== 'string' || !code.trim() || code.length > 80) return false;
        // Persist selection only. Eligibility and amounts always come from fresh API pricing.
        localStorage.setItem(CHECKOUT_PROMO_KEY, JSON.stringify({version:1, owner:scope.owner, cart:scope.cart, code:code.trim().toUpperCase()}));
        return true;
    } catch { return false; }
}

export async function readCheckoutPromo() {
    try {
        const raw = localStorage.getItem(CHECKOUT_PROMO_KEY);
        if (!raw) return null;
        const saved = JSON.parse(raw);
        if (saved?.version !== 1 || typeof saved.code !== 'string' || !saved.code.trim() || saved.code.length > 80) return null;
        const scope = await currentScope();
        return scope && scope.isCurrent() && raw === localStorage.getItem(CHECKOUT_PROMO_KEY) && scope.owner === saved.owner && scope.cart === saved.cart ? saved.code.trim().toUpperCase() : null;
    } catch { return null; }
}
